module.exports = require('./jquery.fillwidth.js');